export const IMAGE_PATH_PREFIX = '/images/imagesForObjects/'
export const DEFAULT_PRODUCT_IMAGE = 'defaultProductImage.jpg'
export const DEFAULT_CATEGORY_IMAGE = 'defaultCategoryImage.jpg'
export const DEFAULT_USER_IMAGE = 'defaultUserImage.jpg'
export const AWS_S3_BUCKET =
  'https://serveflowimagebucket.s3.eu-central-1.amazonaws.com'
